var LogLevel;
(function (LogLevel) {
    LogLevel["LOG"] = "log";
    LogLevel["DEBUG"] = "debug";
    LogLevel["INFO"] = "info";
    LogLevel["WARN"] = "warn";
    LogLevel["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));
const logger = {
    log(level, ...params) {
        /* eslint-disable no-console */
        const method = console[level] ? level : 'log';
        console[method]('[griffith]', ...params);
        /* eslint-enable no-console */
    },
    debug(...args) {
        this.log(LogLevel.DEBUG, ...args);
    },
    info(...args) {
        this.log(LogLevel.INFO, ...args);
    },
    warn(...args) {
        this.log(LogLevel.WARN, ...args);
    },
    error(...args) {
        this.log(LogLevel.ERROR, ...args);
    },
};

function parseUA(userAgent) {
    return {
        isIE: /MSIE|Trident/i.test(userAgent),
        isMobile: /iPhone|iPad|iPod|Android/i.test(userAgent),
        isAndroid: /(android)/i.test(userAgent),
        isSafari: /^((?!chrome|android).)*safari/i.test(userAgent),
    };
}
var ua = parseUA(
// TODO: 加一个 context 让各处访问更好
typeof navigator !== 'undefined' ? navigator.userAgent : '');

/**
 * Copied from https://github.com/video-dev/hls.js/blob/master/src/is-supported.js
 */
function getMediaSource() {
    if (typeof window !== 'undefined') {
        return window.MediaSource || window.WebKitMediaSource;
    }
}
function isMSESupported() {
    const mediaSource = getMediaSource();
    const sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
    const isTypeSupported = mediaSource &&
        typeof mediaSource.isTypeSupported === 'function' &&
        mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    const sourceBufferValidAPI = !sourceBuffer ||
        (sourceBuffer.prototype &&
            typeof sourceBuffer.prototype.appendBuffer === 'function' &&
            typeof sourceBuffer.prototype.remove === 'function');
    return !!isTypeSupported && !!sourceBufferValidAPI;
}

function isHlsNativeSupported() {
    const video = document.createElement('video');
    return Boolean(video.canPlayType('application/vnd.apple.mpegURL'));
}

function sequence(...fns) {
    return (...args) => fns.reduce((_, fn) => fn(...args), null);
}

export { isHlsNativeSupported, isMSESupported, logger, sequence, ua };
